/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnMetricDistrict } from './en-metric-district';
import { EnMetricMeasure } from './en-metric-measure';
import { EnMetricMovement } from './en-metric-movement';
import { EnMetricSide } from './en-metric-side';
 /**
 *
 *
 * @export
 * @interface CreateScreeningMetricItemDto
 */
export interface CreateScreeningMetricItemDto {

    /**
     * Anatomical district (body segment) being measured.
     *
     * @type {EnMetricDistrict}
     * @memberof CreateScreeningMetricItemDto
     */
    district: EnMetricDistrict;

    /**
     * Body side. Bilateral tests send both sides in one request with a different item per side.
     *
     * @type {EnMetricSide}
     * @memberof CreateScreeningMetricItemDto
     */
    side: EnMetricSide;

    /**
     * ROM = range-of-motion angle in degrees. VAS = pain score.
     *
     * @type {EnMetricMeasure}
     * @memberof CreateScreeningMetricItemDto
     */
    measure: EnMetricMeasure;

    /**
     * ROM angle in degrees [-180, 180] for ROM. Pain score [0, 10] for VAS. Sent as a string by the station and parsed server-side.
     *
     * @type {string}
     * @memberof CreateScreeningMetricItemDto
     */
    value: string;

    /**
     * Movement direction. Required on ROM items — the validator refuses a ROM item without it. Must be absent on VAS items — the validator refuses a VAS item that carries it.
     *
     * @type {EnMetricMovement}
     * @memberof CreateScreeningMetricItemDto
     */
    movement?: EnMetricMovement | null;

    /**
     * When the VAS was collected — before or after the test. Required on VAS items. Absent on ROM items.
     *
     * @type {string}
     * @memberof CreateScreeningMetricItemDto
     */
    timepoint?: CreateScreeningMetricItemDtoTimepointEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum CreateScreeningMetricItemDtoTimepointEnum {
    Pre = 'pre',
    Post = 'post'
}

